import { useMemo } from "react";
import { clientContextSchema } from "./schema";
import { getRequiredFields } from "components/form/utils";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { CASESTUDY_FIELDS } from "../../form/constants";
import { fetchCaseStudyDataforForm } from "../../form/read";
import { useCreateCasestudy } from "../../create/mutation";
import { useClientContextDetails } from "../update/mutation";

export const useClientContextForm = ({ casestudyId }) => {
  const navigate = useNavigate();

  const createCasestudyMutation = useCreateCasestudy();
  const updateClientContextMutation = useClientContextDetails();

  const form = useForm({
    resolver: zodResolver(clientContextSchema),
    defaultValues: {
      client_requirement: "",
      nda_level: "",
      industry: "",
      sub_industry: "",
    },
  });

  const requiredFields = useMemo(
    () => getRequiredFields(clientContextSchema),
    [clientContextSchema]
  );

  async function handleCreate(context) {
    const values = context.values;
    const response = await createCasestudyMutation.mutateAsync({
      values,
    });
    navigate(`/case-studies/${response.project.id}`);
  }

  async function handleRead(casestudyId) {
    const fields = [...CASESTUDY_FIELDS];

    const response = await fetchCaseStudyDataforForm({ casestudyId, fields });

    const data = {
      nda_level: response.nda_level ?? "",
      industry: response.industry_v1?.type ?? "",
      sub_industry: response.industry_v1?.id ?? "",
      client_requirement: response.client_requirement ?? "",
    };

    return data;
  }

  async function handleUpdate(id, context) {
    const values = context.dirtyValues;
    const response = await updateClientContextMutation.mutateAsync({
      caseStudyId: id,
      values,
    });

    const data = {
      nda_level: response.nda_level ?? "",
      industry: response.industry_v1?.type ?? "",
      sub_industry: response.industry_v1?.id ?? "",
      client_requirement: response.client_requirement ?? "",
    };

    return data;
  }

  return {
    form,
    requiredFields,
    handleCreate,
    handleRead,
    handleUpdate,
  };
};
